<template>
    <div class="ini-list">
        <div class="listview listview--bordered">
            <ini-list-item v-for="entry in entries" v-bind="entry" @click.native="itemClicked(entry)"></ini-list-item>
        </div>
    </div>
</template>

<script>
    import IniListItem from '@/components/HelpDesk/List/ListItem'

    export default {
        props: {
            title: {
                type: String,
                default: 'List Title'
            },
            entries: {
                type: Array,
                default: () => []
            }
        },

        components:{
            IniListItem
        },


        methods: {
            itemClicked(entry) {
                this.$emit('item-clicked', entry);
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/List/_list.scss";</style>